<template>
  <b-card title="Hey There 🙌">
    <b-card-text>Awesome Content coming soon</b-card-text>
    <b-card-text>Something cool is coming here
      soon</b-card-text>
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>

<style></style>
